import {
 GridFilterModel,
 GridPaginationModel,
 GridSortModel,
} from '@mui/x-data-grid-premium';
import { MutableRefObject, useCallback, useEffect } from 'react';

import { ColPresetType } from '../../../../redux/clientConfiguration/clientConfigurationSlice';
import { StructureType } from '../../../../types/types';
import { CustomGridApi, FetchDataParams } from '../types';
import { prepareFilters, prepareSort } from '../utils';

interface UseTableFetchParams {
 fetchData?: (params: FetchDataParams) => void;
 fetchDataParams?: Record<string, unknown>;
 apiRef: MutableRefObject<CustomGridApi>;
 structure: StructureType[];
 currentColumnsPreset: ColPresetType | null;
 paginationModel: GridPaginationModel;
 isInit: boolean;
 loading: boolean;
 filter: GridFilterModel | undefined;
 sortModel: GridSortModel;
}

const useTableFetch = ({
 fetchData,
 fetchDataParams,
 apiRef,
 structure,
 currentColumnsPreset,
 paginationModel,
 isInit,
 loading,
 filter,
 sortModel,
}: UseTableFetchParams) => {
 const wrapFetchData = useCallback(() => {
  if (typeof fetchData !== 'function') return false;

  const presetFields =
   currentColumnsPreset?.columns
    ?.map((column) => column.field)
    .filter(Boolean) || [];

  const fields = Array.from(new Set(['Id', ...presetFields])).join(',');

  const filters = prepareFilters(
   apiRef.current.state.filter.filterModel.items,
   structure,
  );
  const sort = prepareSort(sortModel, structure);

  fetchData({
   ...fetchDataParams,
   ...(presetFields.length > 0 ? { fields } : {}),
   sort,
   limit: paginationModel.pageSize,
   skip: paginationModel.page * paginationModel.pageSize,
   ...filters,
  });

  return true;
 }, [
  fetchData,
  fetchDataParams,
  currentColumnsPreset,
  paginationModel,
  structure,
  sortModel,
  apiRef,
 ]);

 useEffect(() => {
  if (isInit && !loading && structure.length > 0) {
   wrapFetchData();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [isInit, filter, sortModel, paginationModel, structure]);

 return { wrapFetchData };
};

export default useTableFetch;

